import {
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';

import { useQueryFilterNew } from '../common/use-query-param-new';

import type { TParseFunctions } from '../common/use-query-param-new';
import type { ISmsResponsesFilters } from 'infrastructure/interfaces';

const defaultFilter: ISmsResponsesFilters = {
  page: 1,
};

const parseFunctions: TParseFunctions<ISmsResponsesFilters> = {
  page: parseSearchNumberValue,
  questionAnswers: parseSearchStringValue,
  campaignGuid: parseSearchStringValue,
  language: parseSearchStringValue,
  groupName: parseSearchStringValue,
};

export const useSmsCampaignsResponseQueryFilter = () => {
  return useQueryFilterNew<ISmsResponsesFilters>(
    defaultFilter,
    parseFunctions,
    ['page', 'campaignGuid', 'language', 'groupName'],
  );
};
